import { Pipe, PipeTransform } from "@angular/core";
@Pipe({ name: "searched", pure: false })
export class Searched implements PipeTransform {
  transform(
    categories: any,
    searchText: any,
    searchBy,
    addOther: any,
    stopSort: any
  ): any {
    if (searchText == null || searchText == "") {
      if (categories && categories.length && !stopSort) {
        categories = categories.sort((a: any, b: any): number => {
          let nameA = a[searchBy].toLowerCase(),
            nameB = b[searchBy].toLowerCase(),
            ret = 0;
          if (nameA < nameB)
            //sort string ascending
            ret = -1;
          if (nameA > nameB) ret = 1;
          return ret; //default return value (no sorting)
        });
      }
      return categories;
    }
    let returnArray = [];
    categories.forEach((val) => {
      if (
        String(val[searchBy] || "")
          .toLowerCase()
          .indexOf(searchText.toLowerCase()) !== -1
      ) {
        returnArray.push(val);
      }
    });
    if (!returnArray.length && !addOther) {
      let data = {};
      data[searchBy] = "Value not found !!";
      returnArray.push(data);
    }

    return returnArray;
  }
}

import {
  Component,
  ApplicationRef,
  ElementRef,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "select-search",
  inputs: [
    "list",
    "searchBy",
    "placeHolder",
    "isRequired",
    "module",
    "validation",
    "errors",
    "selected",
    "showerrors",
    "multi",
    "activeBy",
    "clearAllBtn",
    "addOther",
    "stopSort",
    "disabled",
    "checkbox",
  ],
  templateUrl: "./select-search.html",
  styleUrls: ["./select-search.css"],
  providers: [Searched],
})
export class SelectSearchComponent implements OnInit, OnChanges {
  @Output() selectedChange: EventEmitter<any> = new EventEmitter();
  @Output() errorsChange: EventEmitter<any> = new EventEmitter();
  @Output() showerrorsChange: EventEmitter<any> = new EventEmitter();
  @Output("typed") typed: EventEmitter<any> = new EventEmitter();
  @Output("remove") remove: EventEmitter<any> = new EventEmitter();
  addOther: boolean = false;
  others: object = {};
  clearAllBtn: boolean = true;
  list: Array<object> = [];
  module = "";
  multi: boolean = false;
  checkbox: boolean = false;
  disabled: boolean = false;
  search: string = "";
  activeBy: string = "";
  selected;
  lastItem;
  searchBy: string = "";
  placeHolder: string = " -- Select --";
  show: boolean = false;
  iconRotated: boolean = false;
  showError: object = {};
  validation: object = {};
  isRequired: boolean = false;
  stopSort: boolean = true;
  @ViewChild("searchInput") searchInput;
  @ViewChild("inputBox") inputBox;
  @ViewChild("scrollbar") scrollbar;

  // update(): void {
  //   setTimeout(() => {
  //     this.multiItems = [];
  //     this.clearAll(false);
  //     if (this.selected) {
  //       if (!this.activeBy) {
  //         this.activeBy = this.searchBy;
  //       }
  //       this.list.forEach((sval, key) => {
  //         this.selected.forEach((val, key2) => {
  //           if (val[this.activeBy] == sval[this.activeBy]) {
  //             this.list.splice(key, 1);
  //             return false;
  //           }
  //         })
  //       })
  //       this.multiItems = this.selected;
  //     }
  //   }, 300)
  // }
  private searchNameTermStream = new Subject<string>();
  ngOnChanges(changes: SimpleChanges) {
    if (changes["selected"]) {
      if (this.multi) {
        this.multiItems = changes["selected"].currentValue || [];
        if (this.multiItems.length === 0) {
          this.search = "";
        }
      } else if (
        !changes["selected"].previousValue &&
        changes["selected"].currentValue
      ) {
        if (this.module != "serviceGroup")
          this.selectItem(changes["selected"].currentValue);
        setTimeout(() => {
          this.search = changes["selected"].currentValue[this.searchBy];
        }, 500);
      }
    }

    if (changes["selected"] && !changes["selected"]["currentValue"]) {
      this.search = "";
    }
    if (changes["list"]) {
      this.search = "";
      this.lastItem = null;
    }
    // if (changes['list'] && this.multi) {
    //   this.update();
    // }
  }
  ngOnInit() {
    this.others[this.searchBy] = "Others";
    setTimeout(() => {
      this.init();
      this.searchList();
      if (!this.multi && this.selected) this.selectItem(this.selected);
      else {
        // this.multiItems = this.selected || [];
      }
    }, 500);

    this.scrollbar["nativeElement"].onmousedown = function (event) {
      // Do stuff
      return false;
    };
  }
  init() {
    let errors = this.searchInput["errors"];
    if (this.multiItems.length) {
      this.showError = {};
      errors = null;
    }
    this.showerrorsChange.emit(this.showError);
    this.errorsChange.emit(errors);
  }
  constructor(public _el: ElementRef, private ref: ApplicationRef) {
    this.searchNameTermStream.debounceTime(400).subscribe((e: string) => {
      this.typed.emit(e);
      this.init();
    });
  }
  searchList(e = "") {
    this.searchNameTermStream.next(e);
  }
  multiItems: Array<object> = [];
  selectItem(select, i = -1) {
    if (this.checkbox) {
      this.show = true;
      this.iconRotated = true;
    } else {
      this.show = false;
      this.iconRotated = false;
    }
    // In checkbox multi-select mode, do NOT blur the input so the dropdown
    // stays open. The user closes it manually.
    if (!this.checkbox) {
      this.inputBox["nativeElement"].blur();
    }
    if (!select) {
      this.selectedChange.emit("");
      return false;
    }
    let item = select;
    if (item && item[this.searchBy] != "Value not found !!") {
      if (this.multi) {
        if (this.checkbox) {
          const index = this.multiItems.findIndex(mi => mi[this.activeBy || this.searchBy] === select[this.activeBy || this.searchBy]);
          if (index === -1) {
            this.multiItems.push(select);
          } else {
            this.multiItems.splice(index, 1);
          }
        } else {
          this.multiItems.push(select);
        }
        item = this.multiItems;
        this.search = "";
        if (!this.checkbox) {
          this.inputBox["nativeElement"]["placeholder"] = "";
        }
        if (i >= 0 && !this.checkbox) {
          this.list.splice(i, 1);
        }
      } else {
        this.search = item[this.searchBy];
        this.lastItem = item;
      }
      this.selectedChange.emit(item);
      if (!this.checkbox) {
        this.searchList(select[this.searchBy]);
      }
    } else {
      this.selectedChange.emit("");
      this.searchList();
    }
  }
  searchClick() {
    this.search = "";
  }

  searchBlur() {
    setTimeout(() => {
      // In checkbox (multi-select) mode keep the dropdown open so the user
      // can select multiple items before manually closing it.
      if (this.checkbox) return;

      this.search = "";
      this.show = false;
      this.iconRotated = false;
      if (!this.multiItems.length && this.lastItem) {
        this.search = this.lastItem[this.searchBy];
      }
      this.init();
    }, 200);
  }
  searchFocus(searchInput) {
    this.currentIndex = -1;
    this.search = "";
    this.show = true;
    this.iconRotated = true;
    this.searchList();
  }
  removeItem(index, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    if (!this.checkbox) {
      this.list.push(this.multiItems[index]);
    }
    if (this.multiItems.length == 0) {
      this.searchList();
    }
    this.remove.emit(this.multiItems[index]);
    this.multiItems.splice(index, 1);
  }
  removeItemByKey(val, key = "") {
    if (!key) {
      key = this.searchBy;
    }
    this.multiItems.forEach((res, index) => {
      if (res[key] == val) {
        this.removeItem(index, false);
        return false;
      }
    });
  }
  clearAll(fullClean = true) {
    if (fullClean) this.list.push(...this.multiItems);
    this.multiItems = [];
    this.selectItem("");
    this.search = "";
    this.lastItem = "";
    this.searchList();
  }
  currentIndex: number = -1;
  toggleDropdown() {
    if (this.show) {
      this.show = false;
      this.iconRotated = false;
      this.inputBox["nativeElement"].blur();
    } else {
      this.show = true;
      this.iconRotated = true;
      this.inputBox["nativeElement"].focus();
    }
  }

  arrowMove(e, l, searchInput, index?: number): void {
    if (!l) return;

    if (index == 0 || index) this.currentIndex = index;

    if (e.keyCode == 38) {
      //up
      if (this.currentIndex > 0) this.currentIndex--;
    } else if (e.keyCode == 40) {
      //down
      if (this.currentIndex < l - 1) this.currentIndex++;
    } else if (e.keyCode == 13) {
      //down
      this.selectItem(this.list[this.currentIndex], this.currentIndex);
      this.searchBlur();
    }
    if (!index) {
      var myElement = document.getElementById("scrolling_div");
      myElement.scrollTop = this.currentIndex ? this.currentIndex * 24 : 0;
    }
  }

  isItemSelected(item) {
    if (!this.multi) return false;
    return this.multiItems.some(mi => mi[this.activeBy || this.searchBy] === item[this.activeBy || this.searchBy]);
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/directives/select-search.directive.ts